var map = {
	"./Bharat_Electronics_Limited-Logo.svg": 2336,
	"./KLE.jpg": 5153,
	"./KLElogo.png": 3557,
	"./UMDLogo.png": 1204,
	"./UMDlogo.svg": 6207,
	"./ai_security.png": 2256,
	"./airbnbLogo.png": 3783,
	"./annaina.jpg": 5847,
	"./bel.png": 1606,
	"./codeInLogo.webp": 7008,
	"./contactMail.webp": 9729,
	"./contactMailDark.svg": 3527,
	"./deepmind.svg": 8265,
	"./deevia.png": 4175,
	"./deevia_white-300x87.png": 9947,
	"./developerActivity.svg": 36,
	"./facebookLogo.png": 34,
	"./googleAssistant.svg": 760,
	"./googleAssistantLogo.webp": 2905,
	"./grpc_gateway_cover.png": 9540,
	"./harvardLogo.png": 5972,
	"./informal-seal.png": 9542,
	"./jsFramework.svg": 860,
	"./knock-knock.png": 3445,
	"./logos-primary.png": 8323,
	"./manOnTable.svg": 8776,
	"./nextuLogo.webp": 2953,
	"./nokia-refreshed-logo-1_1.jpg": 80,
	"./nokia-refreshed-logo-2_1.png": 3125,
	"./profile-dark.jpeg": 2261,
	"./profile.jpeg": 8270,
	"./programmer.svg": 522,
	"./pwa.webp": 930,
	"./pwaLogo.webp": 9943,
	"./quoraLogo.png": 8967,
	"./saayaHealthLogo.webp": 7788,
	"./skill.svg": 1601,
	"./stanfordLogo.png": 7021,
	"./talksCardBack.svg": 2592,
	"./transform-logo.svg": 4246,
	"./uav_rf_security.jpg": 4327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;